import PolicyLayout from "@/components/site/PolicyLayout";
import Seo from "@/components/site/Seo";
import { BUSINESS } from "@/lib/siteData";

export default function Terms() {
  return (
    <PolicyLayout title="Terms of Service" lastUpdated="January 2026" testId="terms-page">
      <Seo
        title="Terms of Service"
        description="Repair Point Terms of Service — workmanship warranty, no-fix-no-fee policy, customer responsibilities and limitation of liability for PC & Mac repairs."
        path="/terms"
      />
      <h2 className="font-heading text-xl font-semibold">1. Acceptance of terms</h2>
      <p>
        By engaging {BUSINESS.name} for repair or support services you agree to these terms. If you do not
        agree, please do not use our services.
      </p>

      <h2 className="font-heading text-xl font-semibold">2. Scope of services</h2>
      <p>
        We provide independent diagnostic, repair, optimisation, virus removal, data recovery and remote
        support services for Windows PCs and Macs. All work is performed by qualified technicians.
      </p>

      <h2 className="font-heading text-xl font-semibold">3. Quotes and approval</h2>
      <p>
        All chargeable work is preceded by a written quote. Work only begins once you have approved the quote
        in writing or electronically. The diagnostic fee is refundable when you proceed with a repair on the
        same day.
      </p>

      <h2 className="font-heading text-xl font-semibold">4. Workmanship warranty</h2>
      <p>
        We warrant our workmanship for 30 days from completion. If the same fault recurs within that window,
        we will re-perform the work at no labour cost. Parts carry the manufacturer&rsquo;s warranty.
      </p>

      <h2 className="font-heading text-xl font-semibold">5. No-fix-no-fee</h2>
      <p>
        If we cannot resolve the specific issue you booked us for, you will not be charged our labour fee.
        Diagnostic fees are still refunded if you proceed with an alternative repair on the same day.
      </p>

      <h2 className="font-heading text-xl font-semibold">6. Customer responsibilities</h2>
      <ul className="list-disc pl-6 space-y-1.5">
        <li>Back up critical data before handing in your device where possible.</li>
        <li>Provide accurate device passwords solely for diagnostic and repair purposes.</li>
        <li>Collect repaired devices within 30 days of completion notification.</li>
      </ul>

      <h2 className="font-heading text-xl font-semibold">7. Limitation of liability</h2>
      <p>
        Our maximum liability for any claim related to a repair is limited to the amount you paid for that
        repair. We are not liable for indirect or consequential loss, including loss of data where the customer
        has not maintained a separate backup.
      </p>

      <h2 className="font-heading text-xl font-semibold">8. Independent service disclaimer</h2>
      <p>
        {BUSINESS.name} is an independent third-party computer repair service. We are not affiliated with,
        endorsed by, or sponsored by Microsoft, Apple, or any other brand mentioned on this site. All
        trademarks remain the property of their respective owners.
      </p>

      <h2 className="font-heading text-xl font-semibold">9. Contact</h2>
      <p>
        Questions about these terms? Email {BUSINESS.email} or call {BUSINESS.phone}.
      </p>
    </PolicyLayout>
  );
}
